import { render } from "./MainProducts.vue?vue&type=template&id=1b67a218&scoped=true"
import script from "./MainProducts.vue?vue&type=script&lang=js"
export * from "./MainProducts.vue?vue&type=script&lang=js"

import "./MainProducts.vue?vue&type=style&index=0&id=1b67a218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b67a218"]])

export default __exports__